import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../shared/links';
import styles from './AgreementText.css';

const cx = classnames.bind(styles);

function AgreementText({ className }) {
    return (
        <p className={cx('agreementText', className)}>
            {'By proceeding, you agree with\u00A0'}
            <CustomLink
                to={TERMS_OF_USE_LINK}
                target='_blank'
            >
                Terms&nbsp;of&nbsp;Use
            </CustomLink>
            {' and\u00A0'}
            <CustomLink
                to={PRIVACY_POLICY_LINK}
                target='_blank'
            >
                Privacy&nbsp;Policy
            </CustomLink>
        </p>
    );
}

AgreementText.propTypes = {
    className: PropTypes.string
};

AgreementText.defaultProps = {
    className: ''
};

export {
    AgreementText
};
